export default {
  functional: true,
  inject: ["root"],
  props: {
    name: String
  },
  render(h, ctx) {
    // let name = this.$props.name;
    console.log(ctx);
    return h("div", { slot: ctx.props.name }, [
      ctx.injections.root.$scopedSlots[ctx.props.name]()
    ]);
  }
};
